import push from '../../utils/routing';
import { getCommonRoomPath } from './routes';

// eslint-disable-next-line no-undef
export const goToCommonRoom = (spaceId: string, queryParams?: object) => () =>
  push({
    pathname: getCommonRoomPath(spaceId),
    ...(queryParams ? { query: queryParams } : {}),
  });
